import { render, staticRenderFns } from "./TvWinEdit.vue?vue&type=template&id=5f80ef4c&scoped=true&"
import script from "./TvWinEdit.vue?vue&type=script&lang=js&"
export * from "./TvWinEdit.vue?vue&type=script&lang=js&"
import style0 from "./TvWinEdit.vue?vue&type=style&index=0&id=5f80ef4c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f80ef4c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/emotivi-v2-extranet/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5f80ef4c')) {
      api.createRecord('5f80ef4c', component.options)
    } else {
      api.reload('5f80ef4c', component.options)
    }
    module.hot.accept("./TvWinEdit.vue?vue&type=template&id=5f80ef4c&scoped=true&", function () {
      api.rerender('5f80ef4c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/TvWinEdit.vue"
export default component.exports